import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Upload } from '../../lib/lucide-proxy';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import { supabase } from '../../config/supabase';
import { useAuth } from '../../contexts/AuthContext';
import toast from 'react-hot-toast';

const BeerSubmission = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    style: '',
    description: '',
    abv_range: '',
    ibu_range: '',
    pairing: '',
    image_url: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) {
      toast.error('Você precisa estar logado para contribuir.');
      navigate('/login');
      return;
    }

    setLoading(true);
    try {
      const { error } = await supabase
        .from('beer_encyclopedia')
        .insert([
          { ...formData, author_id: user.id, is_approved: false } // Requires moderation
        ]);

      if (error) throw error;
      toast.success('Contribuição enviada! Aguardando aprovação do admin.');
      navigate('/cervejas');
    } catch (error) {
      console.error('Error submitting:', error);
      toast.error('Erro ao enviar contribuição.');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <>
      <Helmet><title>Nova Contribuição - Cerveja Delivery</title></Helmet>
      <div className="min-h-screen bg-cream-300 py-12 px-4">
        <div className="max-w-2xl mx-auto">
          <Button variant="ghost" onClick={() => navigate('/cervejas')} className="mb-6 pl-0 hover:bg-transparent">
            <ArrowLeft className="w-4 h-4 mr-2" /> Voltar para Enciclopédia
          </Button>
          
          <div className="bg-white rounded-2xl shadow-soft p-8">
            <h1 className="font-display font-bold text-2xl text-dark-900 mb-2">Adicionar Cerveja/Estilo</h1>
            <p className="text-dark-500 mb-8">Compartilhe seu conhecimento. Sua contribuição será revisada por nossa equipe.</p>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <Input label="Nome (ou Estilo)" name="name" required value={formData.name} onChange={handleChange} placeholder="Ex: IPA, Stout, Heineken..." />
                <Input label="Estilo Principal" name="style" required value={formData.style} onChange={handleChange} placeholder="Ex: Ale, Lager..." />
              </div>

              <div>
                <label className="block text-sm font-medium text-dark-700 mb-2">Descrição Completa</label>
                <textarea 
                  name="description" 
                  rows={4} 
                  className="input-field" 
                  required
                  value={formData.description} 
                  onChange={handleChange} 
                  placeholder="Descreva as características sensoriais, história..."
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <Input label="Faixa ABV (Álcool)" name="abv_range" value={formData.abv_range} onChange={handleChange} placeholder="Ex: 4.5% - 5.5%" />
                <Input label="Faixa IBU (Amargor)" name="ibu_range" value={formData.ibu_range} onChange={handleChange} placeholder="Ex: 20 - 40" />
              </div>

              <Input label="Harmonização (Sugestões de pratos)" name="pairing" value={formData.pairing} onChange={handleChange} placeholder="Ex: Queijos azuis, Carnes grelhadas..." />
              <Input label="URL da Imagem (Opcional)" name="image_url" value={formData.image_url} onChange={handleChange} placeholder="https://..." />

              <div className="pt-4">
                <Button type="submit" variant="primary" className="w-full" loading={loading}>
                  Enviar para Aprovação
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default BeerSubmission;